
import { getLookupGNAFSuburb } from '@/api';
import DateSelect from '@/components/dashBoard/selectsFields/components/DateSelect/DateSelect.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import SuburbSearchField from '@/components/fields/SuburbSearchField.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Header, SuburbGNAFLookUpData } from '@/models/main';
import { notificationErrorText } from '@/utils/PortalConstants';
import { mapState } from 'vuex';
import { uuidv4 } from '@/utils/Common';

@Component({
  components: {
    BackButton,
    DateSelect,
    SuburbSearchField,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class Suburbs extends Vue {
  private isLoading = false;
  private suburbData: SuburbGNAFLookUpData[] = [];
  private suburbInput = '';
  private postcodeInput = '';

  // {"locality_name": "NANGRAM", "postcode": "4416", "state": "QLD", "locality_alias_name": "CHINCHILLA"}
  private headers: Header[] = [
    { text: 'Suburb', value: 'locality_name', align: 'left' },
    { text: 'Postcode', value: 'postcode', align: 'left' },
    { text: 'State', value: 'state', align: 'left' },
    { text: 'Suburb alias', value: 'locality_alias_name', align: 'left' },
  ];

  // @Watch('suburbInput')
  private parseInput(input) {
    this.getSuburbs();
    return input;
  }

  private getSuburbs() {
    this.isLoading = true;
    getLookupGNAFSuburb(this.suburbInput, this.postcodeInput)
      .then((res: SuburbGNAFLookUpData[]) => {
        // this.suburbData = res;
        this.suburbData = res.map(item => ({ ...item, key: uuidv4() }));
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error Suburbs report',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
